import { graphql, useStaticQuery } from 'gatsby'

const contact = () => {
  const { contact: { socials: { email, phone } } } = useStaticQuery(graphql`
    {
      contact: wpComponent(databaseId: {eq: 43}) {
        socials {
          email
          phone
        }
      }
    }
  `)

  return { email, phone }
}

export default contact
